import { apiPost, notifySuccess } from "@redriver/cinnamon";

const ActionTypes = {
  RejectDeal: "SHEETS/REJECT_DEAL",
};

export const rejectDeal = ({ sheetId }) =>
  apiPost(ActionTypes.RejectDeal, `sheets/${sheetId}/reject-deal`);
